<!-- Show Auth Selection when NOT logged in -->
<app-auth-selection *ngIf="!(loggedIn$ | async)"></app-auth-selection>

<!-- Show Dashboard when logged in -->
<div *ngIf="loggedIn$ | async">
  <div class="apple-dashboard-header apple-fade-in">
    <div class="apple-container">
      <!-- Welcome Section -->
        <h1 class="apple-heading-1">Dashboard</h1>
        <p class="apple-body-secondary">Willkommen zurück! Hier ist deine Übersicht.</p>
      </div>

  </div>
    <!-- Main Content Grid -->
    <div class="apple-container apple-slide-up">
      <app-coin-widget></app-coin-widget>
      
      <!-- Quick Actions -->
      <div class="quick-actions">
        <button class="apple-action-button" (click)="goToTransactions()">
          <mat-icon>account_balance_wallet</mat-icon>
          <span>Meine Transaktionen</span>
          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </div>
